'use client';

import { useState } from 'react';
import { Button } from '../ui/button';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export function SiteFeedback() {
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = () => {
        setSubmitted(true);
    };

    if (submitted) {
        return (
            <div className="text-center my-8">
                <p className="text-gray-400">Thank you for your feedback!</p>
            </div>
        );
    }

    return (
        <Card className="max-w-sm mx-auto my-8 bg-transparent border-gray-700">
            <CardHeader className="pt-4 pb-2">
                <CardTitle className="text-base text-white text-center font-semibold">Was this page helpful?</CardTitle>
            </CardHeader>
            <CardContent className="flex justify-center gap-4 p-4">
                <Button variant="outline" className="bg-gray-800/50 hover:bg-gray-700/50 border-gray-600" size="icon" onClick={handleSubmit} aria-label="Yes, this page was helpful">
                    <ThumbsUp className="w-5 h-5 text-green-500" />
                </Button>
                <Button variant="outline" className="bg-gray-800/50 hover:bg-gray-700/50 border-gray-600" size="icon" onClick={handleSubmit} aria-label="No, this page was not helpful">
                    <ThumbsDown className="w-5 h-5 text-red-500" />
                </Button>
            </CardContent>
        </Card>
    );
}
